import { Body, Container, Header } from './Comments.styled'
import { Typography } from '@mui/material'
import { Button } from 'components/ui'
import { Add } from '@mui/icons-material'

export const Comments = (props: {}) => {
  return (
    <Container>
      <Header>
        <Typography fontWeight="700" fontSize={18}>
          Comments (0)
        </Typography>
        {/* Not available, when impelemnted remove from comments */}
        {/* <Button
          variantType="secondary"
          size="small"
          sx={{
            width: 57,
          }}
        >
          <Add />
        </Button> */}
      </Header>
      {/* <Body>Comments render here</Body> */}
    </Container>
  )
}
